import React, { useState } from 'react';
import TeachingAssignmentComponent from '../../modules/exam/AssignmentCreator';
import BuildingAssignmentManager from '../../modules/exam/BuildingAssignmentManager';

const AssignmentOperationsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'classroom' | 'building'>('classroom');

  return (
    <div className="container-fluid">
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === 'classroom' ? 'active' : ''}`}
            onClick={() => setActiveTab('classroom')}
          >
            Sınıf Bazlı Atama
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link ${activeTab === 'building' ? 'active' : ''}`}
            onClick={() => setActiveTab('building')}
          >
            Bina Görevlisi Atama
          </button>
        </li>
      </ul>
      {activeTab === 'classroom' ? (
        <TeachingAssignmentComponent />
      ) : (
        <BuildingAssignmentManager />
      )}
    </div>
  );
};

export default AssignmentOperationsPage;
